export default __webpack_public_path__ + "media/ConfluenceIntegration.5d0d83e35118961672dbd7dcfed9b85d.svg";